import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateRoleRefreshTable } from "../../../redux/roles/roleSlice";
import RolesCreateRoleForm from "./RolesCreateRoleForm";

export default function RolesCreate() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const navigateToRolesAndRefresh = () => {
    dispatch(updateRoleRefreshTable(true));
    setTimeout(() => {
      dispatch(updateRoleRefreshTable(false));
    }, 1000);
    navigate("/organization-management/roles");
  };

  return (
    <RolesCreateRoleForm
      onSaveSuccess={navigateToRolesAndRefresh}
      onCancel={() => navigate("/organization-management/roles")}
    />
  );
}
